import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";

export const useUpdateProductsMutation = (id: any) => {
  return useMutation({
    mutationFn: (payload: any) => {
      const updatedPayload = {
        ...payload,
        bulkPrice: payload?.bulkPrice ? Number(payload.bulkPrice) * 100 : 0,
        unitPrice: payload?.unitPrice ? Number(payload.unitPrice) * 100 : 0,
        categories: payload?.categories
          ? payload.categories.map((category: { id: string }) => category.id)
          : [],
      };

      return axiosInstance
        .patch(`/products/${id}`, updatedPayload)
        .then((res: any) => res.data);
    },
    onSuccess: async (data: any) => {
      message.success(data?.message);
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.message);
    },
  });
};
